import React from 'react';
import CSWIPSchemesFilterDropdownItem from './CSWIPSchemesFilterDropdownItem';
import PropTypes from 'prop-types';

function CSWIPSchemesFilterDropdown({search}) {

    // const s = settings;

    // let years = Array(5).fill(new Date().getFullYear());

    // if (dateSpan)
    // {
    //     years = Array(dateSpan+1).fill(new Date().getFullYear());
    // }
        
    
    // if(s.appId == 'ourstories'){
    //     clsName = 'filter filter__dropdown';
    // }

    let schemeTypes = [ 'Personal', 'Other' ];   
   
	return (

        <div className="filter-bar">

            <div className="filter filter__dropdown">
                <CSWIPSchemesFilterDropdownItem search={search} title="SchemeType" options={schemeTypes} />
            </div>


        </div>
        
	);
}

CSWIPSchemesFilterDropdown.propTypes = {
    search: PropTypes.object,
    settings: PropTypes.object,
    filters: PropTypes.object,
    entries: PropTypes.object,
	options: PropTypes.object,
	title: PropTypes.string
};

export default CSWIPSchemesFilterDropdown;